import { EventDispatcher } from './EventDispatcher'

class EventBus extends EventDispatcher {
}

export default new EventBus()
